import React from 'react';
import Icon from '../../../components/AppIcon';

const AgentMetricsOverview = ({ timeRange }) => {
  const metrics = [
    {
      title: 'Total Volume',
      value: '$2.4M',
      change: '+18.2%',
      changeType: 'positive',
      icon: 'DollarSign',
      color: 'bg-primary',
      subMetrics: [
        { label: 'Total Transfers', value: '1,847' },
        { label: 'Avg Ticket Size', value: '$1,299' }
      ]
    },
    {
      title: 'Revenue Generated',
      value: '$48.2K',
      change: '+12.5%',
      changeType: 'positive',
      icon: 'TrendingUp',
      color: 'bg-success',
      subMetrics: [
        { label: 'Fees', value: '$32.1K' },
        { label: 'FX Margin', value: '$16.1K' }
      ]
    },
    {
      title: 'Customers Onboarded',
      value: '342',
      change: '+24.1%',
      changeType: 'positive',
      icon: 'UserPlus',
      color: 'bg-accent',
      subMetrics: [
        { label: 'Approval Rate', value: '94.2%' },
        { label: 'Completion Rate', value: '87.5%' }
      ]
    },
    {
      title: 'Operational Quality',
      value: '92.4%',
      change: '+3.2%',
      changeType: 'positive',
      icon: 'Award',
      color: 'bg-warning',
      subMetrics: [
        { label: 'Info Accuracy', value: '96.2%' },
        { label: 'KYC Success', value: '91.8%' }
      ]
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${metric?.color} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} color="white" />
            </div>
            <span className={`text-sm font-medium ${
              metric?.changeType === 'positive' ? 'text-success' : 'text-error'
            }`}>
              {metric?.change}
            </span>
          </div>
          <h3 className="text-sm font-medium text-muted-foreground mb-1">
            {metric?.title}
          </h3>
          <p className="text-2xl font-bold text-foreground mb-4">
            {metric?.value}
          </p>
          <div className="space-y-2 pt-4 border-t border-border">
            {metric?.subMetrics?.map((sub, idx) => (
              <div key={idx} className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">{sub?.label}</span>
                <span className="font-medium text-foreground">{sub?.value}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AgentMetricsOverview;